import type { SampleItemList } from "@services/samples/list/type";

export const SamplesColumns: Array<{
  id: keyof SampleItemList;
  label: string;
}> = [
  { id: "type", label: "Tipo" },
  { id: "destination", label: "Destino" },
  { id: "reporterName", label: "Coletado por" },
  { id: "sampleDate", label: "Data" },
  { id: "attachmentsCount", label: "Anexos" },
] as const;
